import { render, staticRenderFns } from "./saleafter.vue?vue&type=template&id=893b960a&scoped=true&"
import script from "./saleafter.vue?vue&type=script&lang=js&"
export * from "./saleafter.vue?vue&type=script&lang=js&"
import style0 from "./saleafter.vue?vue&type=style&index=0&id=893b960a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893b960a",
  null
  
)

export default component.exports